<template>
  <div
    :id="id"
    ref="data"
  />
</template>
<script>
const echarts = require('echarts')
export default {
  name: "BarChart",
  props: ["id", "data"], // 接受从父组件传回的值
  emits: ['click'],
  data () {
    return {}
  },
  // 实时监听父组件传过来的值
  // 然后执行drawBar方法 重新绘制柱状图
  watch: {
    data: {
      handler (value) {
        this.drawBar(value)
      },
      deep: true// 深度监听
    }
  },
  mounted () {
    this.drawBar(this.data)
  },
  methods: {
    drawBar (data) { // 现在是真正开始画图表的时候
      const barBox = echarts.init(document.getElementById(this.id))
      // 给图表一个指定的容器dom
      const option = data
      // 柱状图的相关结构已经定义好了调用setoption
      barBox.setOption(option, true)
      console.log(option)
      window.addEventListener("resize", function () {
        barBox.resize()
      })
      // 点击事件
      barBox.off('click') // 防止触发两次点击事件
      barBox.on(
        "click",
        (params) => {
          if (params.data) {
            this.$emit('click', params.data)
          }
        }
      )
    }
  }
}
</script>
